import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ReefLogoMark from './ReefLogoMark';

// ==============================|| LOGO (icon + REEF wordmark, replaces Mantis) ||============================== //

export default function LogoMain() {
  return (
    <Stack direction="row" alignItems="center" spacing={1.25}>
      <ReefLogoMark size={35} />
      <Typography
        variant="h4"
        component="span"
        sx={{
          fontWeight: 700,
          letterSpacing: 0.5,
          lineHeight: 1,
          color: 'text.primary'
        }}
      >
        REEF
      </Typography>
    </Stack>
  );
}
